import { Button } from "@mui/material";

export const MuiButton = Button;
